  import axios              from "axios";
  import { api }            from "../_constants";
  import handleResponse     from "./handleResponse";
  import getVoucherUser     from "./handleVoucherUser";
  import getVoucherData     from "./handleVoucherData";
//import getAppStats        from "./handleAppStats";
  import getAppId           from "./handleAppId";
//import getWebServiceCount from "./handleWebServiceCount";

export const wu_BillsService = {
  wu_getCategoriesCompanies,           //Session=N,GET
  wu_should_getCategoriesCompanies,    //util

  wu_bills_billshistory,               //Session=Y,GET
  wu_bills_billshistoryDetail,         //Session=Y,POST
  wu_bills_receipt,                    //Session=Y,POST

  wu_bills_favoritelist,               //Session=Y,GET
  wu_bills_favorite_add,               //Session=Y,POST
  wu_bills_favorite_update,            //Session=Y,POST
  wu_bills_favorite_delete,            //Session=Y,POST

  wu_bills_info_scanSingleRF,          //Session=Y,POST
  wu_bills_info_inputSingleRF,         //Session=Y,POST
  wu_bills_info_billPayment,           //Session=Y,POST
  wu_bills_info_scanBillerRF,          //Session=Y,POST

  wu_bills_payment_getFees,            //Session=Y,POST
  wu_bills_payment_validateFields,     //Session=Y,POST
  wu_bills_payment_pay,                //Session=Y,POST
  wu_bills_payment_finalizeOutbound,   //Session=Y,POST
};
//----------------------------------------------------------------------------------------------------
function wu_getCategoriesCompanies(reqData) {
  const methName = "wu_getCategoriesCompanies ";
  const localUrl = api.url + "/wbrestservices-1.0.0/wbservice/bills/categoriesCompaniesList";

  const config = {
    timeout: api.netTimeout,
    headers: {
      "Content-Type"                : "application/json",
      "Accept"                      : "application/json",
    //"username"                    : getVoucherUser(api.url),//api.username,
    //"password"                    : getVoucherData(api.url),//api.password,
      "appType"                     : api.appType,
      "appId"                       : getAppId(api.appId),//api.appId,
      "platform"                    : api.platform,
      "channel"                     : api.platformWeb,
    //"appStats"                    : getAppStats(api.webappENV),
    //"webServiceCount"             : getWebServiceCount(),
      "appVersion"                  : api.appVersion,
      "apiVersion"                  : api.apiVersion,
      "lang"                        : localStorage.getItem("lang"),
      "Access-Control-Allow-Origin" : api.allowOrigin_val,
      "Cache-control"               : "no-cache, no-store, must-revalidate", //ie11 cache ajax
      "Pragma"                      : "no-cache",
      "Expires"                     : "0",
      "wbDate"                      : api.buildNumber+"/"+api.buildDateAPI,
      "wbEnv"                       : api.webappENV,
    }
  };
  if(api.use_uph){
    config.headers.username = getVoucherUser(api.url);
    config.headers.password = getVoucherData(api.url);
  }
  // const data = {
  //
  // };
  if(api.print_HTTP_URL){console.log(methName+localUrl);}
  return axios
    .get(localUrl, config)
    .then(handleResponse)
    .then(resData => {
      if(api.print_HTTP_RESP_BODY){console.log(resData);}
      if(resData && resData.returnCode===0){
        localStorage.setItem("categoriescompanies",                  JSON.stringify(resData));
        localStorage.setItem("categoriescompanies_RetrieveLastDate", new Date());
      }
      return resData;
    })
    .catch(err => {
      return Promise.reject(err);
    });
}
//----------------------------------------------------------------------------------------------------
function wu_should_getCategoriesCompanies() {
  //console.log("categoriescompanies_RetrieveLastDate = "+new Date());
  //console.log("categoriescompanies_RetrieveLastDate = "+localStorage.getItem("categoriescompanies_RetrieveLastDate"));

  if(api.cache_CategoriesCompanies_enabled === false){
    return true;
  }

  let categoriescompanies = {};
  try { categoriescompanies = JSON.parse(localStorage.getItem("categoriescompanies")); }catch(err){;}
  if(categoriescompanies===null || (typeof categoriescompanies === "undefined")){
    return true;
  }
  if(!categoriescompanies.billers || categoriescompanies.billers.length===0){
    return true;
  }

  let UserWSRetrieveLastDate = new Date(localStorage.getItem("categoriescompanies_RetrieveLastDate"));
  let dateNow                = new Date();
  if(UserWSRetrieveLastDate===null){
      return true;
  }
  else{
      let secondsDiff = (dateNow.getTime()-UserWSRetrieveLastDate.getTime())/1000;
      let minsDiff    = (secondsDiff/60);
      if(minsDiff<0){minsDiff = -minsDiff;}
      if(minsDiff>api.cache_CategoriesCompanies_TTL_min){ return true;  }
      else                                              { return false; }
  }
}
//----------------------------------------------------------------------------------------------------
function wu_bills_billshistory(reqData) {
  const methName = "wu_bills_billshistory ";

//let count     = reqData["count"];
  let startDate = reqData["startDate"];
  let endDate   = reqData["endDate"];

  let localUrl   = "";
  if(startDate === "" || endDate === ""){
      localUrl   = api.url + "/wbrestservices-1.0.0/wbservice/bills/billshistory?count="+reqData.count;
  }
  else{
      localUrl   = api.url + "/wbrestservices-1.0.0/wbservice/bills/billshistory?count="+reqData.count+"&startDate="+reqData.startDate+"&endDate="+reqData.endDate;
  }

  const config = {
    timeout: api.netTimeout,
    headers: {
      "Content-Type"                : "application/json",
      "Accept"                      : "application/json",
    //"username"                    : getVoucherUser(api.url),//api.username,
    //"password"                    : getVoucherData(api.url),//api.password,
      "appType"                     : api.appType,
      "appId"                       : getAppId(api.appId),//api.appId,
      "platform"                    : api.platform,
      "channel"                     : api.platformWeb,
    //"appStats"                    : getAppStats(api.webappENV),
    //"webServiceCount"             : getWebServiceCount(),
      "appVersion"                  : api.appVersion,
      "apiVersion"                  : api.apiVersion,
      "lang"                        : localStorage.getItem("lang"),
      "Access-Control-Allow-Origin" : api.allowOrigin_val,
      "tokenID"                     : localStorage.getItem("tokenID"),
      "Authorization"               : "Bearer "+ localStorage.getItem("accessToken"),
      "Cache-control"               : "no-cache, no-store, must-revalidate", //ie11 cache ajax
      "Pragma"                      : "no-cache",
      "Expires"                     : "0",
      "wbDate"                      : api.buildNumber+"/"+api.buildDateAPI,
      "wbEnv"                       : api.webappENV,
    }
  };
  if(api.use_uph){
    config.headers.username = getVoucherUser(api.url);
    config.headers.password = getVoucherData(api.url);
  }
  if(api.print_HTTP_URL){console.log(methName+localUrl);}
  return axios
    .get(localUrl, config)
    .then(handleResponse)
    .then(resData => {
      if(api.print_HTTP_RESP_BODY){console.log(resData);}
      return resData;
    })
    .catch(err => {
      //-------------
      //token refresh
      //-------------
      //if(err.httpCode===401){
      if(err.message==="Request failed with status code 401"){
        const refreshUrl  = api.url + "/wbrestservices-1.0.0/wbservice/refresh";
        const refreshData = {"accessToken":localStorage.getItem("accessToken"), "refreshToken":localStorage.getItem("refreshToken") };
        return axios
          .post(refreshUrl, refreshData, config)
          .then(handleResponse)
          .then(resData => {
            if(api.print_HTTP_RESP_BODY){console.log(resData);}
            localStorage.setItem("accessToken_RetrieveLastDate", new Date());
            localStorage.setItem("accessToken",  resData.accessToken);
            config.headers["Authorization"] = "Bearer "+ localStorage.getItem("accessToken");
            //--------------
            //repeat request
            //--------------
            return axios
              .get(localUrl, config)
              .then(handleResponse)
              .then(resData => {
                if(api.print_HTTP_RESP_BODY){console.log(resData);}
                return resData;
              })
              .catch(err => {
                return Promise.reject(err);
              });
          })
          .catch(err => {
            return Promise.reject(err);
          });
      }
      else{
        return Promise.reject(err);
      }
    });
}
//----------------------------------------------------------------------------------------------------
function wu_bills_billshistoryDetail(reqData) {
  const methName = "wu_bills_billshistoryDetail ";
  let localUrl   = api.url + "/wbrestservices-1.0.0/wbservice/bills/billshistoryDetail";

  const config = {
    timeout: api.netTimeout,
    headers: {
      "Content-Type"                : "application/json",
      "Accept"                      : "application/json",
    //"username"                    : getVoucherUser(api.url),//api.username,
    //"password"                    : getVoucherData(api.url),//api.password,
      "appType"                     : api.appType,
      "appId"                       : getAppId(api.appId),//api.appId,
      "platform"                    : api.platform,
      "channel"                     : api.platformWeb,
    //"appStats"                    : getAppStats(api.webappENV),
    //"webServiceCount"             : getWebServiceCount(),
      "appVersion"                  : api.appVersion,
      "apiVersion"                  : api.apiVersion,
      "lang"                        : localStorage.getItem("lang"),
      "Access-Control-Allow-Origin" : api.allowOrigin_val,
      "tokenID"                     : localStorage.getItem("tokenID"),
      "Authorization"               : "Bearer "+ localStorage.getItem("accessToken"),
      "Cache-control"               : "no-cache, no-store, must-revalidate", //ie11 cache ajax
      "Pragma"                      : "no-cache",
      "Expires"                     : "0",
      "wbDate"                      : api.buildNumber+"/"+api.buildDateAPI,
      "wbEnv"                       : api.webappENV,
    }
  };
  if(api.use_uph){
    config.headers.username = getVoucherUser(api.url);
    config.headers.password = getVoucherData(api.url);
  }
  const data = {
    "transactionID" : reqData.transactionID
  };
  if(api.print_HTTP_URL){console.log(methName+localUrl);}
  return axios
    .post(localUrl, data, config)
    .then(handleResponse)
    .then(resData => {
      if(api.print_HTTP_RESP_BODY){console.log(resData);}
      return resData;
    })
    .catch(err => {
      //-------------
      //token refresh
      //-------------
      //if(err.httpCode===401){
      if(err.message==="Request failed with status code 401"){
        const refreshUrl  = api.url + "/wbrestservices-1.0.0/wbservice/refresh";
        const refreshData = {"accessToken":localStorage.getItem("accessToken"), "refreshToken":localStorage.getItem("refreshToken") };
        return axios
          .post(refreshUrl, refreshData, config)
          .then(handleResponse)
          .then(resData => {
            if(api.print_HTTP_RESP_BODY){console.log(resData);}
            localStorage.setItem("accessToken_RetrieveLastDate", new Date());
            localStorage.setItem("accessToken",  resData.accessToken);
            config.headers["Authorization"] = "Bearer "+ localStorage.getItem("accessToken");
            //--------------
            //repeat request
            //--------------
            return axios
              .post(localUrl, data, config)
              .then(handleResponse)
              .then(resData => {
                if(api.print_HTTP_RESP_BODY){console.log(resData);}
                return resData;
              })
              .catch(err => {
                return Promise.reject(err);
              });
          })
          .catch(err => {
            return Promise.reject(err);
          });
      }
      else{
        return Promise.reject(err);
      }
    });
}
//----------------------------------------------------------------------------------------------------
function wu_bills_receipt(reqData) {
  const methName = "wu_bills_receipt ";
  let localUrl   = api.url + "/wbrestservices-1.0.0/wbservice/bills/billsreceipt?transactionID="+reqData.transactionID;

  const config = {
    timeout: api.netTimeout,
    headers: {
    //"Content-Type"                : "application/json",
    //"Accept"                      : "application/json",
    //"username"                    : getVoucherUser(api.url),//api.username,
    //"password"                    : getVoucherData(api.url),//api.password,
      "appType"                     : api.appType,
      "appId"                       : getAppId(api.appId),//api.appId,
      "platform"                    : api.platform,
      "channel"                     : api.platformWeb,
    //"appStats"                    : getAppStats(api.webappENV),
    //"webServiceCount"             : getWebServiceCount(),
      "appVersion"                  : api.appVersion,
      "apiVersion"                  : api.apiVersion,
      "lang"                        : localStorage.getItem("lang"),
      "Access-Control-Allow-Origin" : api.allowOrigin_val,
      "tokenID"                     : localStorage.getItem("tokenID"),
      "Authorization"               : "Bearer "+ localStorage.getItem("accessToken"),
      "Cache-control"               : "no-cache, no-store, must-revalidate", //ie11 cache ajax
      "Pragma"                      : "no-cache",
      "Expires"                     : "0",
      "wbDate"                      : api.buildNumber+"/"+api.buildDateAPI,
      "wbEnv"                       : api.webappENV,
    },
    onDownloadProgress: (progressEvent) => {
         let percentCompleted = Math.round(progressEvent.loaded * 100 / progressEvent.total);
         console.log("progressEvent.lengthComputable="+progressEvent.lengthComputable+",percentCompleted="+percentCompleted);
    },
    responseType : "blob"
  };
  if(api.use_uph){
    config.headers.username = getVoucherUser(api.url);
    config.headers.password = getVoucherData(api.url);
  }
  // const data = {
  //
  // };
  if(api.print_HTTP_URL){console.log(methName+localUrl);}
  return axios
    .get(localUrl, config )
    .then(handleResponse)
    .then(resData => {
      if(api.print_HTTP_RESP_BODY){console.log(resData);}
      return resData;
    })
    .catch(err => {
      //-------------
      //token refresh
      //-------------
      //if(err.httpCode===401){
      if(err.message==="Request failed with status code 401"){
        const refreshUrl  = api.url + "/wbrestservices-1.0.0/wbservice/refresh";
        const refreshData = {"accessToken":localStorage.getItem("accessToken"), "refreshToken":localStorage.getItem("refreshToken") };
        return axios
          .post(refreshUrl, refreshData, config)
          .then(handleResponse)
          .then(resData => {
            if(api.print_HTTP_RESP_BODY){console.log(resData);}
            localStorage.setItem("accessToken_RetrieveLastDate", new Date());
            localStorage.setItem("accessToken",  resData.accessToken);
            config.headers["Authorization"] = "Bearer "+ localStorage.getItem("accessToken");
            //--------------
            //repeat request
            //--------------
            return axios
              .get(localUrl, config)
              .then(handleResponse)
              .then(resData => {
                if(api.print_HTTP_RESP_BODY){console.log(resData);}
                return resData;
              })
              .catch(err => {
                return Promise.reject(err);
              });
          })
          .catch(err => {
            return Promise.reject(err);
          });
      }
      else{
        return Promise.reject(err);
      }
    });
}
//----------------------------------------------------------------------------------------------------
//----------------------------------------------------------------------------------------------------
//----------------------------------------------------------------------------------------------------
function wu_bills_favoritelist(reqData) {
  const methName = "wu_bills_favoritelist ";
  let localUrl   = api.url + "/wbrestservices-1.0.0/wbservice/bills/favorite/list?count=20";//+reqData.count;

  const config = {
    timeout: api.netTimeout,
    headers: {
      "Content-Type"                : "application/json",
      "Accept"                      : "application/json",
    //"username"                    : getVoucherUser(api.url),//api.username,
    //"password"                    : getVoucherData(api.url),//api.password,
      "appType"                     : api.appType,
      "appId"                       : getAppId(api.appId),//api.appId,
      "platform"                    : api.platform,
      "channel"                     : api.platformWeb,
    //"appStats"                    : getAppStats(api.webappENV),
    //"webServiceCount"             : getWebServiceCount(),
      "appVersion"                  : api.appVersion,
      "apiVersion"                  : api.apiVersion,
      "lang"                        : localStorage.getItem("lang"),
      "Access-Control-Allow-Origin" : api.allowOrigin_val,
      "tokenID"                     : localStorage.getItem("tokenID"),
      "Authorization"               : "Bearer "+ localStorage.getItem("accessToken"),
      "Cache-control"               : "no-cache, no-store, must-revalidate", //ie11 cache ajax
      "Pragma"                      : "no-cache",
      "Expires"                     : "0",
      "wbDate"                      : api.buildNumber+"/"+api.buildDateAPI,
      "wbEnv"                       : api.webappENV,
    }
  };
  if(api.use_uph){
    config.headers.username = getVoucherUser(api.url);
    config.headers.password = getVoucherData(api.url);
  }
  if(api.print_HTTP_URL){console.log(methName+localUrl);}
  return axios
    .get(localUrl, config)
    .then(handleResponse)
    .then(resData => {
      if(api.print_HTTP_RESP_BODY){console.log(resData);}
      return resData;
    })
    .catch(err => {
      //-------------
      //token refresh
      //-------------
      //if(err.httpCode===401){
      if(err.message==="Request failed with status code 401"){
        const refreshUrl  = api.url + "/wbrestservices-1.0.0/wbservice/refresh";
        const refreshData = {"accessToken":localStorage.getItem("accessToken"), "refreshToken":localStorage.getItem("refreshToken") };
        return axios
          .post(refreshUrl, refreshData, config)
          .then(handleResponse)
          .then(resData => {
            if(api.print_HTTP_RESP_BODY){console.log(resData);}
            localStorage.setItem("accessToken_RetrieveLastDate", new Date());
            localStorage.setItem("accessToken",  resData.accessToken);
            config.headers["Authorization"] = "Bearer "+ localStorage.getItem("accessToken");
            //--------------
            //repeat request
            //--------------
            return axios
              .get(localUrl, config)
              .then(handleResponse)
              .then(resData => {
                if(api.print_HTTP_RESP_BODY){console.log(resData);}
                return resData;
              })
              .catch(err => {
                return Promise.reject(err);
              });
          })
          .catch(err => {
            return Promise.reject(err);
          });
      }
      else{
        return Promise.reject(err);
      }
    });
}
//----------------------------------------------------------------------------------------------------
function wu_bills_favorite_add(reqData) {
  const methName = "wu_bills_favorite_add ";
  let localUrl   = api.url + "/wbrestservices-1.0.0/wbservice/bills/favorite/add";

  const config = {
    timeout: api.netTimeout,
    headers: {
      "Content-Type"                : "application/json",
      "Accept"                      : "application/json",
    //"username"                    : getVoucherUser(api.url),//api.username,
    //"password"                    : getVoucherData(api.url),//api.password,
      "appType"                     : api.appType,
      "appId"                       : getAppId(api.appId),//api.appId,
      "platform"                    : api.platform,
      "channel"                     : api.platformWeb,
    //"appStats"                    : getAppStats(api.webappENV),
    //"webServiceCount"             : getWebServiceCount(),
      "appVersion"                  : api.appVersion,
      "apiVersion"                  : api.apiVersion,
      "lang"                        : localStorage.getItem("lang"),
      "Access-Control-Allow-Origin" : api.allowOrigin_val,
      "tokenID"                     : localStorage.getItem("tokenID"),
      "Authorization"               : "Bearer "+ localStorage.getItem("accessToken"),
      "Cache-control"               : "no-cache, no-store, must-revalidate", //ie11 cache ajax
      "Pragma"                      : "no-cache",
      "Expires"                     : "0",
      "wbDate"                      : api.buildNumber+"/"+api.buildDateAPI,
      "wbEnv"                       : api.webappENV,
    }
  };
  if(api.use_uph){
    config.headers.username = getVoucherUser(api.url);
    config.headers.password = getVoucherData(api.url);
  }
  const data = {
    "alias"         : reqData.alias,
    "transactionID" : reqData.transactionID
  };
  if(api.print_HTTP_URL){console.log(methName+localUrl);}
  return axios
    .post(localUrl, data, config)
    .then(handleResponse)
    .then(resData => {
      if(api.print_HTTP_RESP_BODY){console.log(resData);}
      return resData;
    })
    .catch(err => {
      //-------------
      //token refresh
      //-------------
      //if(err.httpCode===401){
      if(err.message==="Request failed with status code 401"){
        const refreshUrl  = api.url + "/wbrestservices-1.0.0/wbservice/refresh";
        const refreshData = {"accessToken":localStorage.getItem("accessToken"), "refreshToken":localStorage.getItem("refreshToken") };
        return axios
          .post(refreshUrl, refreshData, config)
          .then(handleResponse)
          .then(resData => {
            if(api.print_HTTP_RESP_BODY){console.log(resData);}
            localStorage.setItem("accessToken_RetrieveLastDate", new Date());
            localStorage.setItem("accessToken",  resData.accessToken);
            config.headers["Authorization"] = "Bearer "+ localStorage.getItem("accessToken");
            //--------------
            //repeat request
            //--------------
            return axios
              .post(localUrl, data, config)
              .then(handleResponse)
              .then(resData => {
                if(api.print_HTTP_RESP_BODY){console.log(resData);}
                return resData;
              })
              .catch(err => {
                return Promise.reject(err);
              });
          })
          .catch(err => {
            return Promise.reject(err);
          });
      }
      else{
        return Promise.reject(err);
      }
    });
}
//----------------------------------------------------------------------------------------------------
function wu_bills_favorite_update(reqData) {
  const methName = "wu_bills_favorite_update ";
  let localUrl   = api.url + "/wbrestservices-1.0.0/wbservice/bills/favorite/update";

  const config = {
    timeout: api.netTimeout,
    headers: {
      "Content-Type"                : "application/json",
      "Accept"                      : "application/json",
    //"username"                    : getVoucherUser(api.url),//api.username,
    //"password"                    : getVoucherData(api.url),//api.password,
      "appType"                     : api.appType,
      "appId"                       : getAppId(api.appId),//api.appId,
      "platform"                    : api.platform,
      "channel"                     : api.platformWeb,
    //"appStats"                    : getAppStats(api.webappENV),
    //"webServiceCount"             : getWebServiceCount(),
      "appVersion"                  : api.appVersion,
      "apiVersion"                  : api.apiVersion,
      "lang"                        : localStorage.getItem("lang"),
      "Access-Control-Allow-Origin" : api.allowOrigin_val,
      "tokenID"                     : localStorage.getItem("tokenID"),
      "Authorization"               : "Bearer "+ localStorage.getItem("accessToken"),
      "Cache-control"               : "no-cache, no-store, must-revalidate", //ie11 cache ajax
      "Pragma"                      : "no-cache",
      "Expires"                     : "0",
      "wbDate"                      : api.buildNumber+"/"+api.buildDateAPI,
      "wbEnv"                       : api.webappENV,
    }
  };
  if(api.use_uph){
    config.headers.username = getVoucherUser(api.url);
    config.headers.password = getVoucherData(api.url);
  }
  const data = {
    "alias"         : reqData.alias,
    "transactionID" : reqData.transactionID
  };
  if(api.print_HTTP_URL){console.log(methName+localUrl);}
  return axios
    .post(localUrl, data, config)
    .then(handleResponse)
    .then(resData => {
      if(api.print_HTTP_RESP_BODY){console.log(resData);}
      return resData;
    })
    .catch(err => {
      //-------------
      //token refresh
      //-------------
      //if(err.httpCode===401){
      if(err.message==="Request failed with status code 401"){
        const refreshUrl  = api.url + "/wbrestservices-1.0.0/wbservice/refresh";
        const refreshData = {"accessToken":localStorage.getItem("accessToken"), "refreshToken":localStorage.getItem("refreshToken") };
        return axios
          .post(refreshUrl, refreshData, config)
          .then(handleResponse)
          .then(resData => {
            if(api.print_HTTP_RESP_BODY){console.log(resData);}
            localStorage.setItem("accessToken_RetrieveLastDate", new Date());
            localStorage.setItem("accessToken",  resData.accessToken);
            config.headers["Authorization"] = "Bearer "+ localStorage.getItem("accessToken");
            //--------------
            //repeat request
            //--------------
            return axios
              .post(localUrl, data, config)
              .then(handleResponse)
              .then(resData => {
                if(api.print_HTTP_RESP_BODY){console.log(resData);}
                return resData;
              })
              .catch(err => {
                return Promise.reject(err);
              });
          })
          .catch(err => {
            return Promise.reject(err);
          });
      }
      else{
        return Promise.reject(err);
      }
    });
}
//----------------------------------------------------------------------------------------------------
function wu_bills_favorite_delete(reqData) {
  const methName = "wu_bills_favorite_delete ";
  let localUrl   = api.url + "/wbrestservices-1.0.0/wbservice/bills/favorite/delete";

  const config = {
    timeout: api.netTimeout,
    headers: {
      "Content-Type"                : "application/json",
      "Accept"                      : "application/json",
    //"username"                    : getVoucherUser(api.url),//api.username,
    //"password"                    : getVoucherData(api.url),//api.password,
      "appType"                     : api.appType,
      "appId"                       : getAppId(api.appId),//api.appId,
      "platform"                    : api.platform,
      "channel"                     : api.platformWeb,
    //"appStats"                    : getAppStats(api.webappENV),
    //"webServiceCount"             : getWebServiceCount(),
      "appVersion"                  : api.appVersion,
      "apiVersion"                  : api.apiVersion,
      "lang"                        : localStorage.getItem("lang"),
      "Access-Control-Allow-Origin" : api.allowOrigin_val,
      "tokenID"                     : localStorage.getItem("tokenID"),
      "Authorization"               : "Bearer "+ localStorage.getItem("accessToken"),
      "Cache-control"               : "no-cache, no-store, must-revalidate", //ie11 cache ajax
      "Pragma"                      : "no-cache",
      "Expires"                     : "0",
      "wbDate"                      : api.buildNumber+"/"+api.buildDateAPI,
      "wbEnv"                       : api.webappENV,
    }
  };
  if(api.use_uph){
    config.headers.username = getVoucherUser(api.url);
    config.headers.password = getVoucherData(api.url);
  }
  const data = {
    "transactionID" : reqData.transactionID
  };
  if(api.print_HTTP_URL){console.log(methName+localUrl);}
  return axios
    .post(localUrl, data, config)
    .then(handleResponse)
    .then(resData => {
      if(api.print_HTTP_RESP_BODY){console.log(resData);}
      return resData;
    })
    .catch(err => {
      //-------------
      //token refresh
      //-------------
      //if(err.httpCode===401){
      if(err.message==="Request failed with status code 401"){
        const refreshUrl  = api.url + "/wbrestservices-1.0.0/wbservice/refresh";
        const refreshData = {"accessToken":localStorage.getItem("accessToken"), "refreshToken":localStorage.getItem("refreshToken") };
        return axios
          .post(refreshUrl, refreshData, config)
          .then(handleResponse)
          .then(resData => {
            if(api.print_HTTP_RESP_BODY){console.log(resData);}
            localStorage.setItem("accessToken_RetrieveLastDate", new Date());
            localStorage.setItem("accessToken",  resData.accessToken);
            config.headers["Authorization"] = "Bearer "+ localStorage.getItem("accessToken");
            //--------------
            //repeat request
            //--------------
            return axios
              .post(localUrl, data, config)
              .then(handleResponse)
              .then(resData => {
                if(api.print_HTTP_RESP_BODY){console.log(resData);}
                return resData;
              })
              .catch(err => {
                return Promise.reject(err);
              });
          })
          .catch(err => {
            return Promise.reject(err);
          });
      }
      else{
        return Promise.reject(err);
      }
    });
}
//----------------------------------------------------------------------------------------------------
//----------------------------------------------------------------------------------------------------
//----------------------------------------------------------------------------------------------------
function wu_bills_info_scanSingleRF(reqData) {
  const methName = "wu_bills_info_scanSingleRF ";
  let localUrl   = api.url + "/wbrestservices-1.0.0/wbservice/bills/payment/info/scanSingleRF";

  const config = {
    timeout: api.netTimeout,
    headers: {
      "Content-Type"                : "application/json",
      "Accept"                      : "application/json",
    //"username"                    : getVoucherUser(api.url),//api.username,
    //"password"                    : getVoucherData(api.url),//api.password,
      "appType"                     : api.appType,
      "appId"                       : getAppId(api.appId),//api.appId,
      "platform"                    : api.platform,
      "channel"                     : api.platformWeb,
    //"appStats"                    : getAppStats(api.webappENV),
    //"webServiceCount"             : getWebServiceCount(),
      "appVersion"                  : api.appVersion,
      "apiVersion"                  : api.apiVersion,
      "lang"                        : localStorage.getItem("lang"),
      "Access-Control-Allow-Origin" : api.allowOrigin_val,
      "tokenID"                     : localStorage.getItem("tokenID"),
      "Authorization"               : "Bearer "+ localStorage.getItem("accessToken"),
      "Cache-control"               : "no-cache, no-store, must-revalidate", //ie11 cache ajax
      "Pragma"                      : "no-cache",
      "Expires"                     : "0",
      "wbDate"                      : api.buildNumber+"/"+api.buildDateAPI,
      "wbEnv"                       : api.webappENV,
    }
  };
  if(api.use_uph){
    config.headers.username = getVoucherUser(api.url);
    config.headers.password = getVoucherData(api.url);
  }
  const data = {
    "barcode" : reqData.barcode
  };
  if(api.print_HTTP_URL){console.log(methName+localUrl);}
  return axios
    .post(localUrl, data, config)
    .then(handleResponse)
    .then(resData => {
      if(api.print_HTTP_RESP_BODY){console.log(resData);}
      return resData;
    })
    .catch(err => {
      //-------------
      //token refresh
      //-------------
      //if(err.httpCode===401){
      if(err.message==="Request failed with status code 401"){
        const refreshUrl  = api.url + "/wbrestservices-1.0.0/wbservice/refresh";
        const refreshData = {"accessToken":localStorage.getItem("accessToken"), "refreshToken":localStorage.getItem("refreshToken") };
        return axios
          .post(refreshUrl, refreshData, config)
          .then(handleResponse)
          .then(resData => {
            if(api.print_HTTP_RESP_BODY){console.log(resData);}
            localStorage.setItem("accessToken_RetrieveLastDate", new Date());
            localStorage.setItem("accessToken",  resData.accessToken);
            config.headers["Authorization"] = "Bearer "+ localStorage.getItem("accessToken");
            //--------------
            //repeat request
            //--------------
            return axios
              .post(localUrl, data, config)
              .then(handleResponse)
              .then(resData => {
                if(api.print_HTTP_RESP_BODY){console.log(resData);}
                return resData;
              })
              .catch(err => {
                return Promise.reject(err);
              });
          })
          .catch(err => {
            return Promise.reject(err);
          });
      }
      else{
        return Promise.reject(err);
      }
    });
}
//----------------------------------------------------------------------------------------------------
function wu_bills_info_inputSingleRF(reqData) {
  const methName = "wu_bills_info_inputSingleRF ";
  let localUrl   = api.url + "/wbrestservices-1.0.0/wbservice/bills/payment/info/inputSingleRF";

  const config = {
    timeout: api.netTimeout,
    headers: {
      "Content-Type"                : "application/json",
      "Accept"                      : "application/json",
    //"username"                    : getVoucherUser(api.url),//api.username,
    //"password"                    : getVoucherData(api.url),//api.password,
      "appType"                     : api.appType,
      "appId"                       : getAppId(api.appId),//api.appId,
      "platform"                    : api.platform,
      "channel"                     : api.platformWeb,
    //"appStats"                    : getAppStats(api.webappENV),
    //"webServiceCount"             : getWebServiceCount(),
      "appVersion"                  : api.appVersion,
      "apiVersion"                  : api.apiVersion,
      "lang"                        : localStorage.getItem("lang"),
      "Access-Control-Allow-Origin" : api.allowOrigin_val,
      "tokenID"                     : localStorage.getItem("tokenID"),
      "Authorization"               : "Bearer "+ localStorage.getItem("accessToken"),
      "Cache-control"               : "no-cache, no-store, must-revalidate", //ie11 cache ajax
      "Pragma"                      : "no-cache",
      "Expires"                     : "0",
      "wbDate"                      : api.buildNumber+"/"+api.buildDateAPI,
      "wbEnv"                       : api.webappENV,
    }
  };
  if(api.use_uph){
    config.headers.username = getVoucherUser(api.url);
    config.headers.password = getVoucherData(api.url);
  }
  const data = {
    "rfPaymentCode" : reqData.rfPaymentCode
  };
  if(api.print_HTTP_URL){console.log(methName+localUrl);}
  return axios
    .post(localUrl, data, config)
    .then(handleResponse)
    .then(resData => {
      if(api.print_HTTP_RESP_BODY){console.log(resData);}
      return resData;
    })
    .catch(err => {
      //-------------
      //token refresh
      //-------------
      //if(err.httpCode===401){
      if(err.message==="Request failed with status code 401"){
        const refreshUrl  = api.url + "/wbrestservices-1.0.0/wbservice/refresh";
        const refreshData = {"accessToken":localStorage.getItem("accessToken"), "refreshToken":localStorage.getItem("refreshToken") };
        return axios
          .post(refreshUrl, refreshData, config)
          .then(handleResponse)
          .then(resData => {
            if(api.print_HTTP_RESP_BODY){console.log(resData);}
            localStorage.setItem("accessToken_RetrieveLastDate", new Date());
            localStorage.setItem("accessToken",  resData.accessToken);
            config.headers["Authorization"] = "Bearer "+ localStorage.getItem("accessToken");
            //--------------
            //repeat request
            //--------------
            return axios
              .post(localUrl, data, config)
              .then(handleResponse)
              .then(resData => {
                if(api.print_HTTP_RESP_BODY){console.log(resData);}
                return resData;
              })
              .catch(err => {
                return Promise.reject(err);
              });
          })
          .catch(err => {
            return Promise.reject(err);
          });
      }
      else{
        return Promise.reject(err);
      }
    });
}
//----------------------------------------------------------------------------------------------------
function wu_bills_info_billPayment(reqData) {
  const methName = "wu_bills_info_billPayment ";
  let localUrl   = api.url + "/wbrestservices-1.0.0/wbservice/bills/payment/info/billPayment";

  const config = {
    timeout: api.netTimeout,
    headers: {
      "Content-Type"                : "application/json",
      "Accept"                      : "application/json",
    //"username"                    : getVoucherUser(api.url),//api.username,
    //"password"                    : getVoucherData(api.url),//api.password,
      "appType"                     : api.appType,
      "appId"                       : getAppId(api.appId),//api.appId,
      "platform"                    : api.platform,
      "channel"                     : api.platformWeb,
    //"appStats"                    : getAppStats(api.webappENV),
    //"webServiceCount"             : getWebServiceCount(),
      "appVersion"                  : api.appVersion,
      "apiVersion"                  : api.apiVersion,
      "lang"                        : localStorage.getItem("lang"),
      "Access-Control-Allow-Origin" : api.allowOrigin_val,
      "tokenID"                     : localStorage.getItem("tokenID"),
      "Authorization"               : "Bearer "+ localStorage.getItem("accessToken"),
      "Cache-control"               : "no-cache, no-store, must-revalidate", //ie11 cache ajax
      "Pragma"                      : "no-cache",
      "Expires"                     : "0",
      "wbDate"                      : api.buildNumber+"/"+api.buildDateAPI,
      "wbEnv"                       : api.webappENV,
    }
  };
  if(api.use_uph){
    config.headers.username = getVoucherUser(api.url);
    config.headers.password = getVoucherData(api.url);
  }
  const data = {
    "billerId"      : reqData.billerId,
    "transactionId" : reqData.transactionId
  };
  if(api.print_HTTP_URL){console.log(methName+localUrl);}
  return axios
    .post(localUrl, data, config)
    .then(handleResponse)
    .then(resData => {
      if(api.print_HTTP_RESP_BODY){console.log(resData);}
      return resData;
    })
    .catch(err => {
      //-------------
      //token refresh
      //-------------
      //if(err.httpCode===401){
      if(err.message==="Request failed with status code 401"){
        const refreshUrl  = api.url + "/wbrestservices-1.0.0/wbservice/refresh";
        const refreshData = {"accessToken":localStorage.getItem("accessToken"), "refreshToken":localStorage.getItem("refreshToken") };
        return axios
          .post(refreshUrl, refreshData, config)
          .then(handleResponse)
          .then(resData => {
            if(api.print_HTTP_RESP_BODY){console.log(resData);}
            localStorage.setItem("accessToken_RetrieveLastDate", new Date());
            localStorage.setItem("accessToken",  resData.accessToken);
            config.headers["Authorization"] = "Bearer "+ localStorage.getItem("accessToken");
            //--------------
            //repeat request
            //--------------
            return axios
              .post(localUrl, data, config)
              .then(handleResponse)
              .then(resData => {
                if(api.print_HTTP_RESP_BODY){console.log(resData);}
                return resData;
              })
              .catch(err => {
                return Promise.reject(err);
              });
          })
          .catch(err => {
            return Promise.reject(err);
          });
      }
      else{
        return Promise.reject(err);
      }
    });
}
//----------------------------------------------------------------------------------------------------
function wu_bills_info_scanBillerRF(reqData) {
  const methName = "wu_bills_info_scanBillerRF ";
  let localUrl   = api.url + "/wbrestservices-1.0.0/bills/payment/info/scanBillerRF";

  const config = {
    timeout: api.netTimeout,
    headers: {
      "Content-Type"                : "application/json",
      "Accept"                      : "application/json",
    //"username"                    : getVoucherUser(api.url),//api.username,
    //"password"                    : getVoucherData(api.url),//api.password,
      "appType"                     : api.appType,
      "appId"                       : getAppId(api.appId),//api.appId,
      "platform"                    : api.platform,
      "channel"                     : api.platformWeb,
    //"appStats"                    : getAppStats(api.webappENV),
    //"webServiceCount"             : getWebServiceCount(),
      "appVersion"                  : api.appVersion,
      "apiVersion"                  : api.apiVersion,
      "lang"                        : localStorage.getItem("lang"),
      "Access-Control-Allow-Origin" : api.allowOrigin_val,
      "tokenID"                     : localStorage.getItem("tokenID"),
      "Authorization"               : "Bearer "+ localStorage.getItem("accessToken"),
      "Cache-control"               : "no-cache, no-store, must-revalidate", //ie11 cache ajax
      "Pragma"                      : "no-cache",
      "Expires"                     : "0",
      "wbDate"                      : api.buildNumber+"/"+api.buildDateAPI,
      "wbEnv"                       : api.webappENV,
    }
  };
  if(api.use_uph){
    config.headers.username = getVoucherUser(api.url);
    config.headers.password = getVoucherData(api.url);
  }
  const data = {
    "barcode"  : reqData.barcode,
    "billerId" : reqData.billerId
  };
  if(api.print_HTTP_URL){console.log(methName+localUrl);}
  return axios
    .post(localUrl, data, config)
    .then(handleResponse)
    .then(resData => {
      if(api.print_HTTP_RESP_BODY){console.log(resData);}
      return resData;
    })
    .catch(err => {
      //-------------
      //token refresh
      //-------------
      //if(err.httpCode===401){
      if(err.message==="Request failed with status code 401"){
        const refreshUrl  = api.url + "/wbrestservices-1.0.0/wbservice/refresh";
        const refreshData = {"accessToken":localStorage.getItem("accessToken"), "refreshToken":localStorage.getItem("refreshToken") };
        return axios
          .post(refreshUrl, refreshData, config)
          .then(handleResponse)
          .then(resData => {
            if(api.print_HTTP_RESP_BODY){console.log(resData);}
            localStorage.setItem("accessToken_RetrieveLastDate", new Date());
            localStorage.setItem("accessToken",  resData.accessToken);
            config.headers["Authorization"] = "Bearer "+ localStorage.getItem("accessToken");
            //--------------
            //repeat request
            //--------------
            return axios
              .post(localUrl, data, config)
              .then(handleResponse)
              .then(resData => {
                if(api.print_HTTP_RESP_BODY){console.log(resData);}
                return resData;
              })
              .catch(err => {
                return Promise.reject(err);
              });
          })
          .catch(err => {
            return Promise.reject(err);
          });
      }
      else{
        return Promise.reject(err);
      }
    });
}
//----------------------------------------------------------------------------------------------------
//----------------------------------------------------------------------------------------------------
//----------------------------------------------------------------------------------------------------
function wu_bills_payment_getFees(reqData) {
  const methName = "wu_bills_payment_getFees ";
  let localUrl   = api.url + "/wbrestservices-1.0.0/wbservice/bills/payment/getFees";

  const config = {
    timeout: api.netTimeout,
    headers: {
      "Content-Type"                : "application/json",
      "Accept"                      : "application/json",
    //"username"                    : getVoucherUser(api.url),//api.username,
    //"password"                    : getVoucherData(api.url),//api.password,
      "appType"                     : api.appType,
      "appId"                       : getAppId(api.appId),//api.appId,
      "platform"                    : api.platform,
      "channel"                     : api.platformWeb,
    //"appStats"                    : getAppStats(api.webappENV),
    //"webServiceCount"             : getWebServiceCount(),
      "appVersion"                  : api.appVersion,
      "apiVersion"                  : api.apiVersion,
      "lang"                        : localStorage.getItem("lang"),
      "Access-Control-Allow-Origin" : api.allowOrigin_val,
      "tokenID"                     : localStorage.getItem("tokenID"),
      "Authorization"               : "Bearer "+ localStorage.getItem("accessToken"),
      "Cache-control"               : "no-cache, no-store, must-revalidate", //ie11 cache ajax
      "Pragma"                      : "no-cache",
      "Expires"                     : "0",
      "wbDate"                      : api.buildNumber+"/"+api.buildDateAPI,
      "wbEnv"                       : api.webappENV,
    }
  };
  if(api.use_uph){
    config.headers.username = getVoucherUser(api.url);
    config.headers.password = getVoucherData(api.url);
  }
  const data = {
    "billerId" : reqData.billerId,
    "amount"   : reqData.amount
  };
  if(api.print_HTTP_URL){console.log(methName+localUrl);}
  return axios
    .post(localUrl, data, config)
    .then(handleResponse)
    .then(resData => {
      if(api.print_HTTP_RESP_BODY){console.log(resData);}
      return resData;
    })
    .catch(err => {
      //-------------
      //token refresh
      //-------------
      //if(err.httpCode===401){
      if(err.message==="Request failed with status code 401"){
        const refreshUrl  = api.url + "/wbrestservices-1.0.0/wbservice/refresh";
        const refreshData = {"accessToken":localStorage.getItem("accessToken"), "refreshToken":localStorage.getItem("refreshToken") };
        return axios
          .post(refreshUrl, refreshData, config)
          .then(handleResponse)
          .then(resData => {
            if(api.print_HTTP_RESP_BODY){console.log(resData);}
            localStorage.setItem("accessToken_RetrieveLastDate", new Date());
            localStorage.setItem("accessToken",  resData.accessToken);
            config.headers["Authorization"] = "Bearer "+ localStorage.getItem("accessToken");
            //--------------
            //repeat request
            //--------------
            return axios
              .post(localUrl, data, config)
              .then(handleResponse)
              .then(resData => {
                if(api.print_HTTP_RESP_BODY){console.log(resData);}
                return resData;
              })
              .catch(err => {
                return Promise.reject(err);
              });
          })
          .catch(err => {
            return Promise.reject(err);
          });
      }
      else{
        return Promise.reject(err);
      }
    });
}
//----------------------------------------------------------------------------------------------------
function wu_bills_payment_validateFields(reqData) {
  const methName = "wu_bills_payment_validateFields ";
  let localUrl   = api.url + "/wbrestservices-1.0.0/wbservice/bills/payment/validateFields";

  const config = {
    timeout: api.netTimeout,
    headers: {
      "Content-Type"                : "application/json",
      "Accept"                      : "application/json",
    //"username"                    : getVoucherUser(api.url),//api.username,
    //"password"                    : getVoucherData(api.url),//api.password,
      "appType"                     : api.appType,
      "appId"                       : getAppId(api.appId),//api.appId,
      "platform"                    : api.platform,
      "channel"                     : api.platformWeb,
    //"appStats"                    : getAppStats(api.webappENV),
    //"webServiceCount"             : getWebServiceCount(),
      "appVersion"                  : api.appVersion,
      "apiVersion"                  : api.apiVersion,
      "lang"                        : localStorage.getItem("lang"),
      "Access-Control-Allow-Origin" : api.allowOrigin_val,
      "tokenID"                     : localStorage.getItem("tokenID"),
      "Authorization"               : "Bearer "+ localStorage.getItem("accessToken"),
      "Cache-control"               : "no-cache, no-store, must-revalidate", //ie11 cache ajax
      "Pragma"                      : "no-cache",
      "Expires"                     : "0",
      "wbDate"                      : api.buildNumber+"/"+api.buildDateAPI,
      "wbEnv"                       : api.webappENV,
    }
  };
  if(api.use_uph){
    config.headers.username = getVoucherUser(api.url);
    config.headers.password = getVoucherData(api.url);
  }
  const data = reqData;
  if(api.print_HTTP_URL){console.log(methName+localUrl);}
  return axios
    .post(localUrl, data, config)
    .then(handleResponse)
    .then(resData => {
      if(api.print_HTTP_RESP_BODY){console.log(resData);}
      return resData;
    })
    .catch(err => {
      //-------------
      //token refresh
      //-------------
      //if(err.httpCode===401){
      if(err.message==="Request failed with status code 401"){
        const refreshUrl  = api.url + "/wbrestservices-1.0.0/wbservice/refresh";
        const refreshData = {"accessToken":localStorage.getItem("accessToken"), "refreshToken":localStorage.getItem("refreshToken") };
        return axios
          .post(refreshUrl, refreshData, config)
          .then(handleResponse)
          .then(resData => {
            if(api.print_HTTP_RESP_BODY){console.log(resData);}
            localStorage.setItem("accessToken_RetrieveLastDate", new Date());
            localStorage.setItem("accessToken",  resData.accessToken);
            config.headers["Authorization"] = "Bearer "+ localStorage.getItem("accessToken");
            //--------------
            //repeat request
            //--------------
            return axios
              .post(localUrl, data, config)
              .then(handleResponse)
              .then(resData => {
                if(api.print_HTTP_RESP_BODY){console.log(resData);}
                return resData;
              })
              .catch(err => {
                return Promise.reject(err);
              });
          })
          .catch(err => {
            return Promise.reject(err);
          });
      }
      else{
        return Promise.reject(err);
      }
    });
}
//----------------------------------------------------------------------------------------------------
function wu_bills_payment_pay(reqData) {
  const methName = "wu_bills_payment_pay ";
  let localUrl   = api.url + "/wbrestservices-1.0.0/wbservice/bills/payment/pay";

  const config = {
    timeout: api.netTimeout,
    headers: {
      "Content-Type"                : "application/json",
      "Accept"                      : "application/json",
    //"username"                    : getVoucherUser(api.url),//api.username,
    //"password"                    : getVoucherData(api.url),//api.password,
      "appType"                     : api.appType,
      "appId"                       : getAppId(api.appId),//api.appId,
      "platform"                    : api.platform,
      "channel"                     : api.platformWeb,
    //"appStats"                    : getAppStats(api.webappENV),
    //"webServiceCount"             : getWebServiceCount(),
      "appVersion"                  : api.appVersion,
      "apiVersion"                  : api.apiVersion,
      "lang"                        : localStorage.getItem("lang"),
      "Access-Control-Allow-Origin" : api.allowOrigin_val,
      "tokenID"                     : localStorage.getItem("tokenID"),
      "Authorization"               : "Bearer "+ localStorage.getItem("accessToken"),
      "Cache-control"               : "no-cache, no-store, must-revalidate", //ie11 cache ajax
      "Pragma"                      : "no-cache",
      "Expires"                     : "0",
      "wbDate"                      : api.buildNumber+"/"+api.buildDateAPI,
      "wbEnv"                       : api.webappENV,
    }
  };
  if(api.use_uph){
    config.headers.username = getVoucherUser(api.url);
    config.headers.password = getVoucherData(api.url);
  }
  const data = reqData;
  if(api.print_HTTP_URL){console.log(methName+localUrl);}
  return axios
    .post(localUrl, data, config)
    .then(handleResponse)
    .then(resData => {
      if(api.print_HTTP_RESP_BODY){console.log(resData);}
      return resData;
    })
    .catch(err => {
      //-------------
      //token refresh
      //-------------
      //if(err.httpCode===401){
      if(err.message==="Request failed with status code 401"){
        const refreshUrl  = api.url + "/wbrestservices-1.0.0/wbservice/refresh";
        const refreshData = {"accessToken":localStorage.getItem("accessToken"), "refreshToken":localStorage.getItem("refreshToken") };
        return axios
          .post(refreshUrl, refreshData, config)
          .then(handleResponse)
          .then(resData => {
            if(api.print_HTTP_RESP_BODY){console.log(resData);}
            localStorage.setItem("accessToken_RetrieveLastDate", new Date());
            localStorage.setItem("accessToken",  resData.accessToken);
            config.headers["Authorization"] = "Bearer "+ localStorage.getItem("accessToken");
            //--------------
            //repeat request
            //--------------
            return axios
              .post(localUrl, data, config)
              .then(handleResponse)
              .then(resData => {
                if(api.print_HTTP_RESP_BODY){console.log(resData);}
                return resData;
              })
              .catch(err => {
                return Promise.reject(err);
              });
          })
          .catch(err => {
            return Promise.reject(err);
          });
      }
      else{
        return Promise.reject(err);
      }
    });
}

//----------------------------------------------------------------------------------------------------
function wu_bills_payment_finalizeOutbound(reqData) {
  const methName = "wu_bills_payment_finalizeOutbound ";
  let localUrl   = api.url + "/wbrestservices-1.0.0/wbservice/bills/finalizeOutbound";

  const config = {
    timeout: api.netTimeout,
    headers: {
      "Content-Type"                : "application/json",
      "Accept"                      : "application/json",
    //"username"                    : getVoucherUser(api.url),//api.username,
    //"password"                    : getVoucherData(api.url),//api.password,
      "appType"                     : api.appType,
      "appId"                       : getAppId(api.appId),//api.appId,
      "platform"                    : api.platform,
      "channel"                     : api.platformWeb,
    //"appStats"                    : getAppStats(api.webappENV),
    //"webServiceCount"             : getWebServiceCount(),
      "appVersion"                  : api.appVersion,
      "apiVersion"                  : api.apiVersion,
      "lang"                        : localStorage.getItem("lang"),
      "Access-Control-Allow-Origin" : api.allowOrigin_val,
      "tokenID"                     : localStorage.getItem("tokenID"),
      "Authorization"               : "Bearer "+ localStorage.getItem("accessToken"),
      "Cache-control"               : "no-cache, no-store, must-revalidate", //ie11 cache ajax
      "Pragma"                      : "no-cache",
      "Expires"                     : "0",
      "wbDate"                      : api.buildNumber+"/"+api.buildDateAPI,
      "wbEnv"                       : api.webappENV,
    }
  };
  if(api.use_uph){
    config.headers.username = getVoucherUser(api.url);
    config.headers.password = getVoucherData(api.url);
  }
  const data = reqData;
  if(api.print_HTTP_URL){console.log(methName+localUrl);}
  return axios
    .post(localUrl, data, config)
    .then(handleResponse)
    .then(resData => {
      if(api.print_HTTP_RESP_BODY){console.log(resData);}
      return resData;
    })
    .catch(err => {
      //-------------
      //token refresh
      //-------------
      //if(err.httpCode===401){
      if(err.message==="Request failed with status code 401"){
        const refreshUrl  = api.url + "/wbrestservices-1.0.0/wbservice/refresh";
        const refreshData = {"accessToken":localStorage.getItem("accessToken"), "refreshToken":localStorage.getItem("refreshToken") };
        return axios
          .post(refreshUrl, refreshData, config)
          .then(handleResponse)
          .then(resData => {
            if(api.print_HTTP_RESP_BODY){console.log(resData);}
            localStorage.setItem("accessToken_RetrieveLastDate", new Date());
            localStorage.setItem("accessToken",  resData.accessToken);
            config.headers["Authorization"] = "Bearer "+ localStorage.getItem("accessToken");
            //--------------
            //repeat request
            //--------------
            return axios
              .post(localUrl, data, config)
              .then(handleResponse)
              .then(resData => {
                if(api.print_HTTP_RESP_BODY){console.log(resData);}
                return resData;
              })
              .catch(err => {
                return Promise.reject(err);
              });
          })
          .catch(err => {
            return Promise.reject(err);
          });
      }
      else{
        return Promise.reject(err);
      }
    });
}
//----------------------------------------------------------------------------------------------------
